import { useMemo } from 'react';
import { useSettingsStore } from '@/state/settingsStore';
import type { VoicingPrefs } from './chordShape';

/** Voicing choices and easy mode, for chord diagrams (F4.9, F5.4). */
export function useVoicingPrefs(): VoicingPrefs {
  const choices = useSettingsStore((s) => s.voicingChoices);
  const easy = useSettingsStore((s) => s.easyMode);
  return useMemo(() => ({ choices, easy }), [choices, easy]);
}
